module.exports = __webpack_public_path__ + "img/full1-min.4c780142.png";